export function bounce(target: HTMLElement) {
  target.classList.add('bounce');
  setTimeout(() => {
    target.classList.remove('bounce');
  }, 150);
}
